import { config } from '../../config';
import cn from 'classnames';
import React from 'react';
export var PageChatBlocked = function () {
    var B = config.css.B('-page-chat');
    return (React.createElement("div", { className: cn(B), style: { margin: '20px', display: 'flex' } },
        React.createElement("div", { className: cn("".concat(B, "__messages")), id: "scrollContainer" },
            React.createElement("pre", { style: {
                    padding: '10px',
                    fontSize: '13px',
                    background: '#ffc',
                } },
                React.createElement("strong", { style: { color: 'darkred' } }, "Error"),
                React.createElement("div", { style: { whiteSpace: 'pre-wrap', color: 'gray' } },
                    "Z d\u016Fvodu technick\u00FDch probl\u00E9m\u016F je chat do\u010Dasn\u011B nedostupn\u00FD. Za vznikl\u00E9 probl\u00E9my se omlouv\u00E1me.",
                    React.createElement("br", null),
                    "K\u00F3d chyby: 8106K30")))));
};
